/**
 * Matches DB availability: COALESCE(is_sponsored, false) = false
 * (treats null/undefined as available; only explicit true is sponsored)
 */
export const isKidUnsponsored = (kid) =>
  kid != null && kid.is_sponsored !== true;

/**
 * Kids returned for Sponsor/Fundraiser listings.
 * API already applies available_for_sponsorship; this is a defensive filter only.
 */
export const filterKidsForSponsorListing = (kids) => {
  if (!Array.isArray(kids)) return [];
  return kids.filter(isKidUnsponsored);
};
